var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSpeedStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2H13V12H11V2Z",
    fill: "#4E629F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3H8V8.99954C7.16406 8.37191 6.12598 8 5 8V15C5 18.866 8.13379 22 12 22C15.8662 22 19 18.866 19 15V6H17V15C17 17.7614 14.7617 20 12 20C9.23828 20 7 17.7614 7 15V10.7638C7.61426 11.3131 8 12.1114 8 13V15H9C10.3252 15 11.4502 15.8593 11.8467 17.0511L13.7451 16.4184C13.1855 14.7401 11.7607 13.4574 10 13.1V3Z",
    fill: "#4E629F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3H14V12H16V3Z",
    fill: "#4E629F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeedStop);
export default __webpack_public_path__ + "static/media/icon_speed_stop.0c6f8c83134b1a1a8113666e1541e29f.svg";
export { ForwardRef as ReactComponent };